<!-- <app-survey style="z-index:1000" *ngIf="!showModal && !success">
</app-survey> -->
<app-loading-bar></app-loading-bar>

<div *ngIf="allOrganisations?.length > 0" class="calendar-desktop">
    <div class="calendar-desktop-flex-25">
        <div class="flex" style="    background: var(--accent);
    color: white;">
            <div>
                <div class="orga-name">{{slug.replaceAll('-',' ')}}</div>
                <div class="flex location-hold">
                    <!-- <i style="margin-right:5px" class="fas fa-search-location"></i> -->
                    <div style="margin-right:15px">{{activeLocation?.name}}</div>
                    <div (click)="showChangeLocation()" style="text-decoration: underline;
    color: var(--primary);cursor:pointer">{{'Change' | translate}}</div>
                </div>
            </div>
            <div class="new-reservation-hold hide-desktop">
                <button style="padding: 10px 15px;
                background: white !important;
                color: black;" class="new-reservation-button" (click)="showCreateReservation = true">{{'New Reservation' | translate}}</button>

            </div>
        </div>

        <div class="schedule-item hide-desktop flex column" *ngIf="mobileOfficeBookingData?.length > 0" style="border-bottom: 1px solid #ececec">
            <div class="desktop-item no-hover-bg" style="border-bottom: none;">

                <div class="schedule-item-content flex column">


                    <div class="schedule-item-title">{{'Mobile Office' | translate}} ({{mobileOfficeBookingData?.length}})</div>

                </div>
            </div>


            <div class="flex" style="padding:5px 15px;overflow-x:auto">


                <ng-container *ngFor="let mobileOfficeBooking of mobileOfficeBookingData">
                    <ng-boring-avatars-beam-avatar (click)="onMobileOfficeSelected(mobileOfficeBooking)" [userhash]="mobileOfficeBooking.userIdHash" [location]="mobileOfficeBooking.name" [name]="mobileOfficeBooking.userName" [inputSize]="40"></ng-boring-avatars-beam-avatar>
                </ng-container>



            </div>

        </div>

        <!-- Past booking limit exceeded message -->
        <div *ngIf="pastBookingLimitExceeded" style="background-color: #fff3cd; border: 1px solid #ffc107; border-radius: 4px; padding: 12px 15px; margin-bottom: 15px; color: #856404; font-weight: 500;">
            <i class="fas fa-info-circle" style="margin-right: 8px;"></i>
            {{'You can only view bookings from the current and previous month for data privacy reasons.' | translate}}
        </div>

        <app-calendar [events]="events" [activeDate]="activeDate" [showEventDetail]="true" [minAllowedDate]="getEarliestAllowedDate()" (activeDateChange)="setActiveDate($event)" (pastBookingLimitExceededChange)="pastBookingLimitExceeded = $event"></app-calendar>

        <div class="flex column only-desktop" style="flex:1">
            <h1 style="text-align: center;" *ngIf="activeLocation?.mapUrl">{{'Location Map' | translate}}</h1>
            <img *ngIf="activeLocation" (click)="openMapFullscreen()" style="object-fit: contain;
            max-width: 25vw;
            align-self: center; margin-top: auto;margin-bottom: auto;cursor: pointer;" [ngClass]="{'placeholderPadding': !activeLocation?.mapUrl}" [src]="activeLocation?.mapUrl ? getMapUrl(activeLocation.mapUrl) : '../../assets/img/crewcus-logo' ">


        </div>
    </div>
    <div class="only-desktop desktop-flex-1" style="overflow-y: scroll;">
        <div class="flex">
            <div class="schedule">{{'Reservations' | translate}} {{activeDate | date: 'mediumDate':undefined:lang }} {{'(' + (activeDateEvents ? activeDateEvents.length : '0') + ')'}}: </div>
            <div class="new-reservation-hold only-desktop">
                <button class="rebrand primary" (click)="showCreateReservation = true">{{'New Reservation' | translate}}</button>

            </div>
        </div>

        <div class="schedule-item flex column" *ngIf="mobileOfficeBookingData?.length > 0" style="border-bottom: 1px solid #ececec">
            <div class="desktop-item no-hover-bg" style="border-bottom: none;">

                <div class="schedule-item-content flex column">


                    <div class="schedule-item-title">{{'Mobile Office' | translate}} ({{mobileOfficeBookingData?.length}})</div>

                </div>
            </div>


            <div class="flex" style="padding:5px 15px;overflow-x:auto">


                <ng-container *ngFor="let mobileOfficeBooking of mobileOfficeBookingData">
                    <ng-boring-avatars-beam-avatar (click)="onMobileOfficeSelected(mobileOfficeBooking)" [userhash]="mobileOfficeBooking.userIdHash" [location]="mobileOfficeBooking.name" [name]="mobileOfficeBooking.userName" [inputSize]="40"></ng-boring-avatars-beam-avatar>
                </ng-container>



            </div>

        </div>

        <div class="schedule-item flex" *ngIf="activeDateEvents?.length === 0">
            <div class="desktop-item">

                <div class="schedule-item-content flex column">

                    <div class="room-and-time"> </div>
                    <div class="schedule-item-title">{{'No Reservations' | translate}}</div>
                    <div class="schedule-item-user">{{'There are no reservations for the selected date and/or location' | translate}}</div>
                </div>
            </div>
        </div>

        <div (click)="onEventSelected(event)" class="schedule-item flex" [ngClass]="{'active-element': event.itemid === activeEvent?.itemid}" *ngFor="let event of activeDateEvents">

            <div class="desktop-item">
                <div style="width: 25px">
                    <div class="dot"></div>
                </div>
                <div class="schedule-item-content flex column">

                    <div class="room-and-time">{{isDayToday(event.endTime) ? ('Today' | translate) : event.startTime | date: 'mediumDate':undefined:lang }}, {{event.startTime | date: 'shortTime':undefined:lang}} - {{event.endTime | date: 'shortTime':undefined:lang}} </div>
                    <div class="schedule-item-title">{{event.room}} - {{event.title}}</div>
                    <div class="schedule-item-user">{{event.username}}</div>
                </div>
            </div>

        </div>


    </div>

    <div [ngStyle]="{'flex': activeEvent ? '0 0 25%' : '0'}" style="
    border-left: 1px solid var(--fourth);    transition-duration: .3s;
    transform: translateX(0vw);    background: white;" [ngClass]="{'show-sidebar-right': activeEvent}" class="only-desktop flex">


        <div class="flex column" *ngIf="activeEvent" style="font-size:medium;position: relative">

            <div (click)="activeEvent = null" class="close-right"><i class="fa fas fa-times"></i></div>
            <h1 style="padding: 0px 15px;font-size:xx-large">{{activeEvent?.title }}
                <span class="tag" *ngIf="isOwnBooking(activeEvent?.userid)">{{'Your Booking' | translate}}</span>
            </h1>
            <div style="max-height: 30vh;min-height:30vh;
        overflow: hidden;display:flex">
                <img style="width:100%;object-fit: contain;max-width: 250px;
                margin: auto;" [ngClass]="{'placeholderImage': !activeEvent?.mapUrlLocation}" [src]=" '../../../assets/img/crewcus-logo' ">
            </div>
            <div style="padding: 10px 15px;">
                <div>{{'Location' | translate}}:
                    <div style="font-weight:bold">{{activeEvent?.location}} {{'- ' + activeEvent?.room}}</div>
                </div>
            </div>
            <div class="flex" style="place-content: space-between;">
                <div style="padding: 10px 15px;">{{'Start of Reservation' | translate}}:
                    <div>{{'End of Reservation' | translate}}:</div>
                </div>

                <div style="padding: 10px 15px;">
                    <div>{{activeEvent?.startTime | date: 'medium':undefined:lang}}</div>
                    <div>{{activeEvent?.endTime | date: 'medium':undefined:lang}}</div>
                </div>





            </div>

            <div class="flex" style="place-content: space-between;">
                <div style="padding: 10px 15px;">{{'Booked by' | translate}}:

                </div>

                <div style="padding: 10px 15px;">
                    <div>{{activeEvent?.username}}</div>

                </div>





            </div>

            <button *ngIf="isOwnBooking(activeEvent?.userid)" (click)="showDeleteBookingModal()" class="secondary rebrand">{{'Delete Booking' | translate}}</button>
            <button *ngIf="showSuperAdmin" (click)="showDeleteBookingModal()" class="secondary rebrand">[Superadmin] {{'Delete Booking' | translate}}</button>

            <!-- Recovery code deletion link for users who lost their session -->
            <div style="text-align: center; margin-top: 20px; padding: 0 15px;">
                <a (click)="showDeleteBookingWithRecoveryCodeModal = true" style="color: var(--primary); text-decoration: underline; cursor: pointer; font-size: 12px;">
                    {{'Can\'t delete your booking? Click here to delete using your recovery code' | translate}}
                </a>
            </div>

        </div>

    </div>

    <app-create-reservation [username]="username" [bookedSlotsForActiveDay]="bookedSlotsForActiveDay" [activeLocation]="activeLocation" *ngIf="showCreateReservation" [activeDate]="activeDate" (onClose)="onCreateReservationClose($event)"></app-create-reservation>


    <div class="modal" [ngClass]="{'active': showLocationChangeModal}">

        <div class="content  ">
            <i class="fas fa-times" (click)="showLocationChangeModal = false"></i>
            <div class="flex column overflow-hidden">


                <div class="slider" id="onboarding-slider">

                    <div class="flex column step">
                        <span class="subtitle">{{'Select Location' | translate}}</span>

                        <div class="location-hold-modal">
                            <div *ngFor="let location of locations">

                                <span style="cursor:pointer" (click)="setActiveLocation(location)" [ngClass]="{'active-item': location._id === activeLocation._id }">{{location.name}}</span>
                            </div>
                        </div>

                    </div>


                </div>


            </div>
        </div>
        <div class="backdrop"></div>
    </div>
</div>




<div *ngIf="allOrganisations?.length === 0" style="padding:0px 15px">
    <img style="max-height:20vh;width:100%" src="../../assets/img/office-work.svg">
    <h1 class="loading-placeholder-text">{{'There is nothing here. Sorry.' | translate}}</h1>
    <div class="loading-placeholder-text">{{'If you think you have the correct URL to your workplace, please contact your Administrator.' | translate}}</div>
</div>

<!-- Recovery Code Deletion Modal -->
<div class="modal" [ngClass]="{'active': showDeleteBookingWithRecoveryCodeModal}">
    <div class="content" style="position: relative; display: flex; justify-content: center; align-items: flex-start;">
        <i class="fas fa-times" (click)="showDeleteBookingWithRecoveryCodeModal = false" style="position: absolute; top: 10px; right: 10px; cursor: pointer;"></i>
        <div class="flex column overflow-hidden">
            <div class="slider" id="onboarding-slider">
                <div class="flex column step" style="width: 90%; text-align: center; align-items: center; padding: 20px;">
                    <img style="margin: auto; width: 100%; object-fit: contain;" src="../../../assets/img/booking.svg">
                    <span class="subtitle">{{'Delete Booking with Recovery Code' | translate}}</span>
                    <div class="description" style="width: 100%;">
                        {{'Enter your recovery code to delete this booking' | translate}}
                    </div>

                    <input 
                        type="text" 
                        [(ngModel)]="recoveryCodeForDelete"
                        placeholder="{{'Enter recovery code' | translate}}"
                        maxlength="9"
                        style="
                            width: 100%;
                            padding: 10px;
                            margin: 15px 0 10px 0;
                            border: 1px solid #ccc;
                            border-radius: 4px;
                            font-size: 14px;
                            box-sizing: border-box;
                        "
                    />

                    <button (click)="deleteBookingWithRecoveryCode()" class="primary rebrand red" style="width: 100%; margin-bottom: 15px;">
                        {{'Delete' | translate}}
                    </button>

                    <div style="text-align: center;">
                        <a (click)="showDeleteBookingWithRecoveryCodeModal = false" style="color: var(--primary); text-decoration: underline; cursor: pointer; font-size: 14px;">
                            {{'Cancel' | translate}}
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="backdrop" (click)="showDeleteBookingWithRecoveryCodeModal = false"></div>
</div>

<app-tab-bar [activeTab]="1"></app-tab-bar>


<div class="modal" [ngClass]="{'active': showDeleteConfirm}">

    <div class="content  ">
        <i class="fas fa-times" (click)="showDeleteConfirm = false"></i>
        <div class="flex column overflow-hidden">


            <div class="slider" id="onboarding-slider">

                <div class="flex column step" *ngIf="!showDeleteSuccess">
                    <img style="margin: auto;
                    width: 100%;object-fit: contain;" src="../../../assets/img/booking.svg">
                    <span class="subtitle">{{'Confirm Delete' | translate}}</span>

                    <div class="description">
                        {{'Do you really want to delete this reservation? This process cannot be undone.' | translate}}
                    </div>

                    <div class="button-holder">
                        <button (click)="deleteBooking()" class="primary rebrand red">{{'Delete' | translate}}</button>
                    </div>

                </div>

                <div class="flex column step" *ngIf="showDeleteSuccess">
                    <img style="margin: auto;
                    width: 100%;object-fit: contain;" src="../../../assets/img/booking.svg">
                    <h1 style="text-align: center;">{{'Delete Successful' | translate}}!</h1>

                    <div class="button-holder">
                        <button (click)="confirmModal()" class="primary rebrand">{{'OK' | translate}}</button>
                    </div>

                </div>


            </div>


        </div>
    </div>
    <div class="backdrop"></div>
</div>


<app-mobile-office-floating (onClose)="onCreateReservationClose($event)" [username]="username" [activeDate]="activeDate" [activeLocation]="activeLocation" *ngIf="activeOrganisation?.mobileOffice && !this.isForbiddenMobileOffice"></app-mobile-office-floating>

<div class="modal" [ngClass]="{'active': showMapFullscreenModal}">
    <div class="content" style="max-width: 90vw; max-height: 90vh; padding: 20px;">
        <i class="fas fa-times" (click)="closeMapFullscreen()" style="position: absolute; top: 10px; right: 10px; cursor: pointer; font-size: 24px; color: #333;"></i>
        <img *ngIf="fullscreenMapUrl" style="width: 100%; height: 100%; object-fit: contain;" [src]="fullscreenMapUrl">
    </div>
    <div class="backdrop" (click)="closeMapFullscreen()"></div>
</div>

